@if (logs && logs.length > 0) {
  <div class="form-card">
    <div class="form-section">
      <div class="section-header">
        <mat-icon class="section-icon">history</mat-icon>
        <h3 class="section-title">Historia zmian</h3>
      </div>
      <div class="section-content">
        <div class="logs-container">
          @for (log of logs; track log) {
            <div class="log-entry">
              <div class="log-header">
                <div class="log-user">
                  <mat-icon>person</mat-icon>
                  {{ log.user_email }}
                </div>
                <div class="log-date">
                  <mat-icon>schedule</mat-icon>
                  {{ log.timestamp | date:'dd.MM.yyyy HH:mm:ss' }}
                </div>
              </div>
              <div class="log-details" >
                @if (log.error) {
                  <div class="log-item">
                    <span class="log-label">Error message:</span>
                    <span class="log-value">{{ log.error }}</span>
                  </div>
                }
                <div class="log-item">
                  <span class="log-label">Akcja:</span>
                  <span class="log-value">{{ getActionLabel(log.method) }}</span>
                </div>
                <div class="log-item">
                  <span class="log-label">Moduł:</span>
                  <span class="log-value">{{ log.controller }}</span>
                </div>
                <div class="log-item">
                  <span class="log-label">Adres:</span>
                  <span class="log-value">{{ log.path }}</span>
                </div>
                <div class="log-item">
                  <span class="log-label">Metoda:</span>
                  <span class="log-value">{{ log.method }}</span>
                </div>
                <div class="log-item">
                  <span class="log-label">IP:</span>
                  <span class="log-value">{{ log.client_ip }}</span>
                </div>
                @if (log.data) {
                  <div class="log-item">
                    <span class="log-label">Dane:</span>
                    <div class="log-data-content">
                      <app-log-data-display [data]="log.data"></app-log-data-display>
                    </div>
                  </div>
                }
                @if (log.response_body) {
                  <div class="log-item">
                    <span class="log-label">Odpowiedź:</span>
                    <div class="log-data-content">
                      <app-log-data-display [data]="log.response_body"></app-log-data-display>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
